@if (type) {
  <div class="mt-3 mb-3 p-3 rounded-lg prose dark:prose-invert !max-w-none" [class]="alertClass">
    <ng-content></ng-content>
  </div>
}
